import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import Button from 'uikit/Button';

import Icon from 'uikit/Icon';

import styles from './DownloadApp.module.scss';

const cx = classNames.bind(styles);

const AddToHomeScreen = ({ browser, handleClose, t }) => (
  <aside className={cx('container')}>
    <div className={cx('popup')}>
      <Button
        as="a"
        className={cx('download')}
        href={
          browser === 'iOS'
            ? 'https://apps.apple.com/us/app/wooflash/6443394551'
            : 'https://play.google.com/store/apps/details?id=com.wooclap.wooflash'
        }
        intent="dark"
        rel="nofollow noreferrer noopener"
        target="blank"
      >
        {t('App/AddToHomeScreen/download')}
      </Button>
      <button
        aria-label={t('App/AddToHomeScreen/aria-close')}
        className={cx('close')}
        onClick={handleClose}
        type="button"
      >
        <Icon name="times" />
      </button>
    </div>
  </aside>
);
AddToHomeScreen.propTypes = {
  browser: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default AddToHomeScreen;
